"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getJSONToYAML = getJSONToYAML;
var _jsonToPrettyYaml = require("json-to-pretty-yaml");
var _jsonlintMod = require("jsonlint-mod");
function getJSONToYAML(_ref) {
  var input = _ref.input;
  var json = (0, _jsonlintMod.parse)(input);
  return (0, _jsonToPrettyYaml.stringify)(json);
}